var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71427 14.9885L1.57141 16.4285L3.01141 11.2856L12.4286 1.91417C12.535 1.80532 12.6621 1.71883 12.8024 1.65978C12.9427 1.60073 13.0935 1.57031 13.2457 1.57031C13.3979 1.57031 13.5486 1.60073 13.689 1.65978C13.8293 1.71883 13.9564 1.80532 14.0628 1.91417L16.0857 3.94846C16.1928 4.0547 16.2778 4.1811 16.3359 4.32037C16.3939 4.45964 16.4238 4.60901 16.4238 4.75988C16.4238 4.91076 16.3939 5.06013 16.3359 5.1994C16.2778 5.33867 16.1928 5.46507 16.0857 5.57131L6.71427 14.9885Z",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPost);
export default __webpack_public_path__ + "static/media/edit-Post.80f423aebad481c159253cef6d31f3c6.svg";
export { ForwardRef as ReactComponent };